export const FormLogin = {
  bindings: {
    isLoading: '<',
    onSubmit: '&',
  },

  template: `
    <form class="voome-form"
      name="form"
      ng-submit="$ctrl.onSubmit({ data: form.data })"
      novalidate>
      <form-group-row>
        <form-group-left>
          <form-label for="email">Email</form-label>
        </form-group-left>
        <form-group-right>
          <form-input
            form="form"
            type="email"
            name="email"
            required="true"
            is-focus="true"
            errors="{
              required: 'This is a required field.',
              email: 'Must be a valid email address.',
            }">
          </form-input>
        </form-group-right>
      </form-group-row>
      <form-group-row>
        <form-group-left>
          <form-label for="password">Password</form-label>
        </form-group-left>
        <form-group-right>
          <form-input
            form="form"
            type="password"
            name="password"
            required="true"
            errors="{ required: 'This is a required field.' }">
          </form-input>
        </form-group-right>
      </form-group-row>
      <div class="form-group form-row justify-content-end">
        <div class="col-sm-8">
          <label class="checkbox p-2 small font-size-sm-base">
            <input class="mr-2" type="checkbox" ng-model="form.data.rememberMe">
            Remember me on this device
          </label>
          <div class="d-flex justify-content-between justify-content-sm-start align-items-center">
            <button-primary
              ng-type="submit"
              ng-disabled="form.$invalid || $ctrl.isLoading">
              <spinner is-loading="$ctrl.isLoading">Login</spinner>
            </button-primary>
            <span class="px-3 text-gray-400">|</span>
            <a class="small font-size-sm-base"
              ui-sref="resetPassword">Forgot Password?</a>
          </div>
        </div>
      </div>
      <hr>
      <div class="form-group form-row justify-content-center">
            <a class="small font-size-sm-base"
              ui-sref="signup">Don't you have an account? Sign up!</a>
      </div>
    </form>`,

  controller($timeout, $scope) {
    'ngInject';

    return {
      $onInit() {
        $timeout(() => {
          ['email', 'password'].forEach(field =>
            this.autoFillSetValidate($scope.form[field])
          );
        }, 1000);
      },

      autoFillSetValidate(input) {
        input.$setValidity(
          'required',
          input.$$element.is('*:-webkit-autofill')
        );
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/FormLogin/FormLogin.js